var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 47,
    viewBox: "0 0 176 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 47,
    rx: 12,
    fill: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.79 25.56c-2.773.013-5.01 2.261-5.002 5.025.008 2.764 2.26 4.999 5.034 4.994 2.772-.004 5.017-2.246 5.017-5.01a4.93 4.93 0 0 0-1.459-3.572 4.963 4.963 0 0 0-3.59-1.438zm0 8.05a3.053 3.053 0 0 1-2.966-1.722 3.034 3.034 0 0 1 .52-3.383 3.058 3.058 0 0 1 3.346-.76 3.041 3.041 0 0 1 1.938 2.824 2.894 2.894 0 0 1-.775 2.118 2.913 2.913 0 0 1-2.063.924zm-11.01-8.05c-2.774.006-5.018 2.252-5.014 5.017.005 2.766 2.256 5.004 5.03 5.002 2.774-.002 5.022-2.244 5.022-5.01a4.93 4.93 0 0 0-1.459-3.572 4.963 4.963 0 0 0-3.59-1.438h.011zm0 8.05a3.053 3.053 0 0 1-2.973-1.713 3.034 3.034 0 0 1 .51-3.386 3.058 3.058 0 0 1 3.348-.766 3.042 3.042 0 0 1 1.942 2.824 2.894 2.894 0 0 1-.776 2.118 2.913 2.913 0 0 1-2.063.924h.012zm-13.114-6.506v2.122h5.108c-.08.999-.496 1.942-1.182 2.675a5.236 5.236 0 0 1-3.938 1.557c-3.135 0-5.677-2.534-5.677-5.659s2.542-5.658 5.677-5.658a5.45 5.45 0 0 1 3.867 1.52l1.502-1.497a7.45 7.45 0 0 0-5.357-2.204 7.823 7.823 0 0 0-7.023 3.803 7.771 7.771 0 0 0 0 7.966 7.823 7.823 0 0 0 7.023 3.803 7.108 7.108 0 0 0 5.451-2.18 7.06 7.06 0 0 0 1.845-4.975 6.896 6.896 0 0 0-.118-1.332l-7.178.059zm53.582 1.65a4.73 4.73 0 0 0-4.305-3.195 4.738 4.738 0 0 0-3.454 1.484 4.705 4.705 0 0 0-1.276 3.526 4.896 4.896 0 0 0 1.427 3.562 4.928 4.928 0 0 0 3.563 1.448 5.008 5.008 0 0 0 4.187-2.216l-1.715-1.179a2.877 2.877 0 0 1-2.472 1.391 2.555 2.555 0 0 1-2.436-1.52l6.729-2.77-.248-.531zm-6.859 1.674a2.738 2.738 0 0 1 .696-2.012 2.76 2.76 0 0 1 1.929-.912 1.953 1.953 0 0 1 1.869 1.061l-4.494 1.863zm-5.464 4.857h2.212V20.55h-2.212v14.735zm-3.618-8.606h-.083a3.553 3.553 0 0 0-2.649-1.178 5.029 5.029 0 0 0-4.794 5.015 5.029 5.029 0 0 0 4.794 5.016 3.435 3.435 0 0 0 2.649-1.179h.071v.72c0 1.92-1.029 2.946-2.685 2.946a2.778 2.778 0 0 1-2.53-1.78l-1.928.802A4.79 4.79 0 0 0 98.61 40c2.59 0 4.731-1.52 4.731-5.222v-8.924h-2.034v.825zm-2.531 6.932a3.057 3.057 0 0 1-2.794-3.042 3.057 3.057 0 0 1 2.794-3.04 2.84 2.84 0 0 1 1.985.956c.506.572.758 1.324.699 2.084a2.798 2.798 0 0 1-.695 2.096 2.817 2.817 0 0 1-2 .946h.011zm28.831-13.061h-5.286v14.735h2.211v-5.588h3.087a4.603 4.603 0 0 0 4.257-2.187 4.571 4.571 0 0 0 0-4.774 4.603 4.603 0 0 0-4.257-2.187h-.012zm0 7.072h-3.087v-5.021h3.134a2.533 2.533 0 0 1 2.537 2.528 2.533 2.533 0 0 1-2.537 2.529l-.047-.036zm13.635-2.122a4.142 4.142 0 0 0-3.938 2.252l1.963.813a2.094 2.094 0 0 1 2.01-1.084 2.134 2.134 0 0 1 1.582.455c.445.357.727.877.784 1.443v.153a4.901 4.901 0 0 0-2.306-.566c-2.117 0-4.258 1.179-4.258 3.313.042.919.456 1.782 1.146 2.392.691.611 1.6.917 2.52.85a3.112 3.112 0 0 0 2.838-1.415h.071v1.179h2.129v-5.67c0-2.582-1.963-4.08-4.482-4.08l-.059-.035zm-.272 8.075c-.721 0-1.727-.365-1.727-1.25 0-1.178 1.254-1.567 2.366-1.567a3.937 3.937 0 0 1 2.01.495 2.67 2.67 0 0 1-2.59 2.358l-.059-.036zm12.571-7.72-2.531 6.388h-.071l-2.625-6.389h-2.365l3.937 8.935-2.246 4.963h2.306L156 25.854h-2.459zm-19.879 9.43h2.211V20.55h-2.211v14.735z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.287 11.991c.04.874-.28 1.726-.887 2.358a3.447 3.447 0 0 1-2.601 1.05 3.725 3.725 0 0 1-3.416-2.3 3.704 3.704 0 0 1 .802-4.031A3.553 3.553 0 0 1 59.8 8.007c.5-.002.995.099 1.454.295a2.92 2.92 0 0 1 1.112.79l-.627.624a2.369 2.369 0 0 0-1.94-.837 2.748 2.748 0 0 0-1.981.83 2.73 2.73 0 0 0-.774 2 2.782 2.782 0 0 0 1.683 2.592 2.798 2.798 0 0 0 3.047-.553c.364-.393.574-.904.592-1.438h-2.566v-.85h3.44c.032.176.048.353.048.531zm5.416-2.947H65.51v2.24h2.91v.849h-2.91v2.24h3.193v.872h-4.139V8.172h4.14v.872zm3.88 6.2h-.912v-6.2h-1.986v-.872h4.931v.872h-2.034v6.2zm5.51 0V8.173h.91v7.073h-.91zm4.955 0h-.91v-6.2H80.15v-.872h4.873v.872h-1.975v6.2zm11.21-.919a3.698 3.698 0 0 1-5.203 0 3.81 3.81 0 0 1 0-5.245 3.672 3.672 0 0 1 5.203 0 3.799 3.799 0 0 1 0 5.245zm-4.529-.589a2.738 2.738 0 0 0 3.856 0 3.01 3.01 0 0 0 0-4.055 2.738 2.738 0 0 0-3.856 0 3.01 3.01 0 0 0 0 4.055zm6.86 1.509V8.172h1.11l3.454 5.505V8.172h.91v7.073h-.946L97.511 9.48v5.764h-.923z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.237
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.556 8.809a2.353 2.353 0 0 0-.544 1.65v26.075c-.036.6.159 1.19.544 1.65l.083.083L34.29 23.673v-.341L19.639 8.726l-.083.083z",
    fill: "url(#39ped024ra)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m39.14 28.542-4.849-4.869v-.341l4.849-4.88.106.058 5.806 3.29c1.656.93 1.656 2.463 0 3.406l-5.782 3.277-.13.059z",
    fill: "url(#sz78hpgzib)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m39.28 28.471-4.99-4.974-14.734 14.688c.696.61 1.73.64 2.46.07l17.277-9.784",
    fill: "url(#y2azus1gic)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.281 18.522 22.004 8.738a1.932 1.932 0 0 0-2.46.07L34.29 23.498l4.99-4.975z",
    fill: "url(#chzate92yd)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M39.139 28.365 22.004 38.09a1.98 1.98 0 0 1-2.366 0l-.082.083.082.082c.7.527 1.666.527 2.366 0l17.277-9.784-.142-.106z",
    fill: "#000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M19.556 38.02a2.353 2.353 0 0 1-.544-1.65v.176c-.036.599.159 1.19.544 1.65l.083-.082-.083-.094zm25.496-12.991-5.913 3.336.107.106 5.806-3.277a2.063 2.063 0 0 0 1.183-1.697 2.193 2.193 0 0 1-1.183 1.532z",
    fill: "#000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "m22.004 8.903 23.048 13.061c.61.3 1.048.867 1.182 1.533a2.063 2.063 0 0 0-1.182-1.698L22.004 8.738C20.348 7.807 19 8.585 19 10.471v.177c.035-1.898 1.36-2.676 3.004-1.745z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "39ped024ra",
    x1: 28.336,
    y1: 10.188,
    x2: 15.815,
    y2: 22.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sz78hpgzib",
    x1: 47.216,
    y1: 23.497,
    x2: 18.61,
    y2: 23.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y2azus1gic",
    x1: 36.573,
    y1: 28.185,
    x2: 15.184,
    y2: 49.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chzate92yd",
    x1: 15.842,
    y1: 6.536,
    x2: 25.389,
    y2: 16.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.b84a25106180f5392bad4c6b7fe43fa3.svg";
export { ForwardRef as ReactComponent };